export const localeMk = {
  systemName:
    "Систем за електронско аплицирање за трајна и времена измена на режим за сообраќај",
  temporaryTrafficChange: "Времена измена на режим за сообраќај",
  permanentTrafficChange: "Трајна измена на режим за сообраќај",
  invalidUsernameOrPassword: "Невалидно корисничко име или лозинка",
  userNotFound: "Корисникот не е пронајден",
  authenticationFailed: "Неуспешна автентикација",
  emailRequired: "Е-поштата е задолжителна",
  invalidEmailFormat: "Невалиден формат на е-пошта",
  firstNameRequired: "Името e задолжителнo",
  lastNameRequired: "Презимето е задолжително",
  headquartersRequired: "Адресата е задолжителна",
  cityRequired: "Град е задолжително",
  phoneRequired: "Телефонскиот број е задолжителен",
  trafficPlanPdfRequired: "Сообраќаен проект PDF е задолжителен",
  onlyPdfFilesAllowed: "Дозволени се само PDF датотеки",
  trafficPlanDwgRequired: "Сообраќаен проект DWG е задолжителен",
  onlyDwgFilesAllowed: "Дозволени се само DWG датотеки",
  urbanPlanPdfRequired: "Урбанистички план PDF е задолжителен",
  urbanPlanDwgRequired: "Урбанистички план DWG е задолжителен",
  onlyDwgOrPdfFilesAllowed: "Дозволени се само DWG или PDF датотеки",
  projectRevisionRequired: "Ревизијата е задолжителна",
  "Network Error":
    "Проблем со поврзување до серверите на Министерството за транспорт. Ве молиме обидете се повторно подоцна.",
  projectTitleRequired: "Називот на проектот е задолжителен",
  projectBureauNameRequired: "Називот на проектантското биро е задолжителен",
  projectTechnicalNumberRequired: "Техничкиот број на проектот е задолжителен",
  locationDescriptionRequired: "Описот на локацијата е задолжителен",
};
